<template>
  <v-form ref="form" v-model="formValid" class="flex" @submit.prevent="submit()" lazy-validation>
    <MongoFields
      ref="mongoFields"
      v-model="form"
      title="Document"
      :defaultForm="currentDefaultForm"
      :schema="schemaWithDiscriminator"
      :mongooseSchema="mongooseSchema"
      :formRules="formRules"
      :rowClasses="rowClasses"
      :expand="true"
      :flat="flat"
      :readonly="readonly"
    />
    <v-flex v-if="showDetails" xs12 mt-4>
      <small>*indicates required field</small>
    </v-flex>
  </v-form>
</template>

<script>
  import MongoFields from './MongoFields'
  import { objectToArray, deepmerge, debounce } from '../../libs/utils'
  import { getDefaultModelValues, HIDDEN_FIELDS_FOR_INSERT, getObjectValueFromSchema, getTableRules } from '../../libs/mongo-datatable'
  import { schemaGenerator } from '../../configs/schemas'
  import { createMongooseSchema } from '../../services/mongo-connector.service'
  import { DataRevision } from '../../libs/data-revision'

  export default {
    props: {
      value: { required: false, default: () => ({}) },
      defaultForm: { required: false, default: () => ({}) },
      schema: { type: Object, required: true },
      discriminators: { type: Object, required: false, default: null },
      discriminatorKey: { type: String, required: false, default: null },
      rowClasses: { type: String, required: false },
      showDetails: { type: Boolean, required: false, default: true },
      expand: { type: Boolean, required: false, default: false },
      flat: { type: Boolean, required: false, default: false },
      readonly: { type: Boolean, required: false, default: false }
    },
    data () {
      return {
        defaultInputValues: {},
        formValid: true,
        form: {},
        discriminatorSchema: null,
        discriminator: {
          started: false,
          value: undefined,
          formStates: new DataRevision(1),
          defaultForm: undefined
        }
      }
    },
    computed: {
      mongooseSchema () {
        return createMongooseSchema(this.schemaWithDiscriminator)
      },
      schemaProps () {
        return objectToArray(this.schemaWithDiscriminator).filter(
          item => !HIDDEN_FIELDS_FOR_INSERT.includes(item.key)
        )
      },
      schemaWithDiscriminator () {
        return this.discriminatorSchema || this.schema
      },
      currentDefaultForm () {
        return this.discriminator.defaultForm || this.defaultForm
      },
      formRules () {
        return getTableRules(
          this.form,
          createMongooseSchema(this.schemaWithDiscriminator)
        )
      }
    },
    watch: {
      'form': {
        deep: true,
        handler (val) {
          // console.log('form', JSON.stringify(val, null, 2))
          this.forceUpdateForm(val)
        }
      },
      'defaultForm': {
        deep: true,
        handler (val) {
          this.reset()
        }
      }
    },
    mounted () {
      if (this.discriminators && this.discriminatorKey) {
        const updateDiscriminator = (val, old) => {
          this.discriminator.formStates.add({ ...this.form }, old)
          this.discriminatorSchema = schemaGenerator(
            { [this.discriminatorKey]: val },
            this.schema,
            this.discriminators,
            this.discriminatorKey
          )
          this.$nextTick(() => {
            const form = getObjectValueFromSchema(
              this.discriminator.formStates.getMergedDataGroup(
                old,
                { [this.discriminatorKey]: val }
              ),
              this.discriminatorSchema
            )
            this.discriminator.defaultForm = { ...form }
          })
        }
        this.$watch(`form.${this.discriminatorKey}`, (val, old) => {
          if (this.discriminator.started) {
            if (this.discriminator.value !== val) {
              this.discriminator.value = val
              updateDiscriminator(val, old)
            }
          } else {
            this.discriminator.started = true
            updateDiscriminator(val, old)
          }
        }, { immediate: true, deep: true })
      }
      this.reset()
      this.init()
    },
    methods: {
      init () {
        this.defaultInputValues = getDefaultModelValues(this.schemaWithDiscriminator)
        this.form = deepmerge(
          this.defaultInputValues,
          this.defaultForm
        )
        this.formValid = true
      },
      reset () {
        this.discriminator.formStates.reset()
        this.discriminator.defaultForm = undefined
        if (!Object.keys(this.defaultForm).length) {
          this.$refs.form.reset()
        }
        this.$refs.mongoFields.reset()
        // this.$emit('input', val)
        this.$nextTick(() => {
          this.init()
        })
      },
      validate () {
        return this.$refs.form.validate()
      },
      submit () {
        const valid = this.validate()
        console.log('this.formValid', valid)
        return valid
      },
      forceUpdateForm: debounce(function (val) {
        this.$emit('input', val)
        // FIXME: Force update to `v-form` to fix the form not updated new inputs
        this.$nextTick(() => this.$refs.form.$forceUpdate())
      }, 20)
    },
    components: {
      MongoFields
    }
  }
</script>

